// Generated by script, don't edit it please.
import createSvgIcon from '../createSvgIcon';
import PublicOpinionSvg from '@rsuite/icon-font/lib/application/PublicOpinion';
var PublicOpinion = createSvgIcon({
  as: PublicOpinionSvg,
  ariaLabel: 'public opinion',
  category: 'application',
  displayName: 'PublicOpinion'
});
export default PublicOpinion;